var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M38.868 21.1319C38.868 19.6406 38.7445 18.5524 38.4773 17.4238H21.1006V24.1548H31.3003C31.0947 25.8275 29.9843 28.3467 27.5165 30.0394L27.4819 30.2647L32.9761 34.4359L33.3568 34.4731C36.8526 31.3091 38.868 26.6538 38.868 21.1319Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M21.0995 38.8669C26.0964 38.8669 30.2915 37.2546 33.3556 34.4735L27.5154 30.0398C25.9526 31.1079 23.855 31.8535 21.0995 31.8535C16.2052 31.8535 12.0513 28.6896 10.5706 24.3164L10.3535 24.3345L4.64063 28.6674L4.56592 28.8709C7.60937 34.7959 13.8609 38.8669 21.0995 38.8669Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M10.5717 24.3153C10.181 23.1868 9.95486 21.9775 9.95486 20.7281C9.95486 19.4785 10.181 18.2694 10.5511 17.1409L10.5408 16.9005L4.75626 12.498L4.567 12.5863C3.31265 15.0449 2.5929 17.8059 2.5929 20.7281C2.5929 23.6503 3.31265 26.4111 4.567 28.8698L10.5717 24.3153Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M21.0996 9.60494C24.5748 9.60494 26.9191 11.0761 28.2558 12.3055L33.4791 7.30756C30.2712 4.38541 26.0966 2.5918 21.0996 2.5918C13.8609 2.5918 7.60938 6.66264 4.56592 12.5875L10.5501 17.1421C12.0514 12.769 16.2053 9.60494 21.0996 9.60494Z",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c14f4a7ed1e44460493db7c391cf5fd5.svg";
export { ForwardRef as ReactComponent };